const getters = {
    getCurrentThonYear(state){
        return state.currentThonYear;
    }
}
export default getters